var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDestinationTracking(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 103.693,
    height: 114.732,
    viewBox: "0 0 103.693 114.732",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "destination_tracking",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10122",
    "data-name": "Group 10122",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12004",
    "data-name": "Path 12004",
    d: "M94.57,57.332c0-4.586-2.144-8.026-6.032-10.469a3.32,3.32,0,0,1-1.4-1.695C85.2,39.036,83.353,32.8,81.558,26.623A24.547,24.547,0,0,1,60.77,4.339a7.186,7.186,0,0,0-2.144-.3H35.993c-3.988,0-6.431,2.393-6.431,6.431v5.384H25.724c-6.182,0-10.419,3.24-12.164,9.173-1.994,6.78-4.038,13.51-6.132,20.29a2.374,2.374,0,0,1-1.1,1.4A12,12,0,0,0,0,57.781V80.214a7.281,7.281,0,0,0,.15,1.795C.8,85.05,2.891,86.5,5.932,86.894c0,1.944-.05,3.888,0,5.783a5.873,5.873,0,0,0,5.883,5.932c1.695.05,3.39,0,5.035,0,4.537,0,6.78-2.293,6.83-6.83V86.845H70.94v5.833a5.915,5.915,0,0,0,5.932,5.932c1.845.05,3.739,0,5.583,0a5.94,5.94,0,0,0,6.232-6.232V86.994c4.686-1.246,5.932-2.842,5.932-7.627,0-7.328,0-14.706-.05-22.035ZM23.131,34.151c.548-1.745,1.2-3.44,1.6-5.234.249-1.047.7-1.246,1.695-1.246H68.248c.947,0,1.346.2,1.6,1.2,1.6,5.434,3.29,10.868,4.985,16.5H19.841Q21.486,39.684,23.131,34.151Zm.5,37.838a5.9,5.9,0,0,1-5.883-5.932,5.83,5.83,0,0,1,5.932-5.833,5.883,5.883,0,1,1-.05,11.765Zm47.26,0a5.883,5.883,0,1,1,5.982-5.833A5.937,5.937,0,0,1,70.89,71.989Z",
    transform: "translate(0 16.1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12005",
    "data-name": "Path 12005",
    d: "M21.6,4.683a2.493,2.493,0,1,1-4.985,0A2.468,2.468,0,0,1,19.1,2.19,2.5,2.5,0,0,1,21.6,4.683Z",
    transform: "translate(66.195 8.728)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12006",
    "data-name": "Path 12006",
    d: "M31.815,0a18.414,18.414,0,0,0-18.4,18.4A18.164,18.164,0,0,0,20.5,32.853a15.5,15.5,0,0,0,3.44,2.193,18.79,18.79,0,0,0,7.877,1.745A18.4,18.4,0,0,0,31.815,0Zm6.63,15.055A13.854,13.854,0,0,1,37,18.994c-1.745,3.589-3.44,7.129-5.185,10.718-1.745-3.589-3.44-7.129-5.185-10.718a13.854,13.854,0,0,1-1.446-3.938,6.878,6.878,0,0,1,6.63-7.976A6.878,6.878,0,0,1,38.446,15.055Z",
    transform: "translate(53.482)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDestinationTracking);
export default __webpack_public_path__ + "static/media/destination_tracking.a1ce87cddb40ca9ffb1bb7b6e43827e4.svg";
export { ForwardRef as ReactComponent };